// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__IV3o6","cpam":"Footer_cpam__P2yZ5","fp":"Footer_fp__rNoH-"};